// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RightSidebar__wrapper-ce431d {
  position: relative;
  inset-inline-end: 360px;
  background-color: var(--addition-40_50);
  height: 100vh;
  overflow: hidden;
}

.RightSidebar__container-b8972b {
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 360px;
  position: relative;
  border-left: 1px solid var(--base-20);
  background-color: var(--base-0);
  box-sizing: border-box;
}

.RightSidebar__rounded-container-c4837b {
  border-radius: 16px 16px 0 0;
  margin-top: 72px;
  height: calc(100% - 72px);
  overflow: hidden;
}

.RightSidebar__body-beb80a {
  height: 100%;
  overflow: auto;
  padding-bottom: 8px;
}

.RightSidebar__compact-body-abf96b {
  height: 100%;
  overflow: auto;
}

.RightSidebar__header-b0adf3 {
  display: flex;
  min-height: 72px;
  align-items: center;
  padding: 0 16px;
}

.RightSidebar__back-d27900 {
  margin-inline-end: 8px;
}

.RightSidebar__close-eb38b2 {
  margin-inline-start: auto;
}

.RightSidebar__title-ea1d4e {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-inline-end: 12px;
  flex: 1;
  font: var(--font-body-1);
  letter-spacing: var(--font-spacing-body-1);
  color: var(--base-110);
}

.RightSidebar__actions-b52262 {
  display: flex;
  gap: 10px;
  align-items: center;
}

.RightSidebar__minimized-container-b12166 {
  position: absolute;
  width: 360px;
  display: flex;
  flex-direction: column;
  bottom: 0;
  background-color: var(--base-0);
  border-radius: 16px 16px 0 0;
}`, "",{"version":3,"sources":["webpack://./src/main/Calendar/Content/RightSidebar/RightSidebar.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,uBAAA;EACA,uCAAA;EACA,aAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,qCAAA;EACA,+BAAA;EACA,sBAAA;AACF;;AAEA;EACE,4BAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;AACF;;AAEA;EACE,YAAA;EACA,cAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,OAAA;EACA,wBAAA;EACA,0CAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,+BAAA;EACA,4BAAA;AACF","sourcesContent":[".wrapper {\n  position: relative;\n  inset-inline-end: 360px;\n  background-color: var(--addition-40_50);\n  height: 100vh;\n  overflow: hidden;\n}\n\n.container {\n  overflow: hidden;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  width: 360px;\n  position: relative;\n  border-left: 1px solid var(--base-20);\n  background-color: var(--base-0);\n  box-sizing: border-box;\n}\n\n.rounded-container {\n  border-radius: 16px 16px 0 0;\n  margin-top: 72px;\n  height: calc(100% - 72px);\n  overflow: hidden;\n}\n\n.body {\n  height: 100%;\n  overflow: auto;\n  padding-bottom: 8px;\n}\n\n.compact-body {\n  height: 100%;\n  overflow: auto;\n}\n\n.header {\n  display: flex;\n  min-height: 72px;\n  align-items: center;\n  padding: 0 16px;\n}\n\n.back {\n  margin-inline-end: 8px;\n}\n\n.close {\n  margin-inline-start: auto;\n}\n\n.title {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  margin-inline-end: 12px;\n  flex: 1;\n  font: var(--font-body-1);\n  letter-spacing: var(--font-spacing-body-1);\n  color: var(--base-110);\n}\n\n.actions {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.minimized-container {\n  position: absolute;\n  width: 360px;\n  display: flex;\n  flex-direction: column;\n  bottom: 0;\n  background-color: var(--base-0);\n  border-radius: 16px 16px 0 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `RightSidebar__wrapper-ce431d`,
	"container": `RightSidebar__container-b8972b`,
	"rounded-container": `RightSidebar__rounded-container-c4837b`,
	"roundedContainer": `RightSidebar__rounded-container-c4837b`,
	"body": `RightSidebar__body-beb80a`,
	"compact-body": `RightSidebar__compact-body-abf96b`,
	"compactBody": `RightSidebar__compact-body-abf96b`,
	"header": `RightSidebar__header-b0adf3`,
	"back": `RightSidebar__back-d27900`,
	"close": `RightSidebar__close-eb38b2`,
	"title": `RightSidebar__title-ea1d4e`,
	"actions": `RightSidebar__actions-b52262`,
	"minimized-container": `RightSidebar__minimized-container-b12166`,
	"minimizedContainer": `RightSidebar__minimized-container-b12166`
};
module.exports = ___CSS_LOADER_EXPORT___;
